import { FC } from 'react';

import { Checkbox, FormControlLabel } from '@mui/material';

import { BsCheckSquareFill } from 'react-icons/bs';
import { BsSquare } from 'react-icons/bs';

import styles from './CheckBox.module.scss';

type Props = {
  checked: boolean;
  onClick: () => void;
  label: string | React.ReactNode;
  disabled?: boolean;
};

const CheckBox: FC<Props> = ({ checked, onClick, label, disabled = false }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          icon={<BsSquare />}
          checkedIcon={<BsCheckSquareFill />}
          className={styles.muiCheckbox}
          checked={checked}
          disabled={disabled}
          onChange={onClick}
        />
      }
      label={label}
      className={styles.muiLabel}
    />
  );
};

export default CheckBox;
